import React, { memo } from 'react';
import { SignalSuggestion } from '../../types';
import { SignalCard } from './SignalCard';

interface SignalListProps {
  signals: SignalSuggestion[];
  selectedSignals: Set<string>;
  savedSignalNames: Set<string>;
  expandedSignalName: string | null;
  onToggleSignal: (signalName: string) => void;
  onSaveSignal: (e: React.MouseEvent, signal: SignalSuggestion) => void;
  onExpandToggle: (signalName: string | null) => void;
}

/**
 * List container for signal cards.
 * Manages signal selection and expansion state.
 */
export const SignalList = memo<SignalListProps>(({
  signals,
  selectedSignals,
  savedSignalNames,
  expandedSignalName,
  onToggleSignal,
  onSaveSignal,
  onExpandToggle,
}) => {
  return (
    <div className="space-y-2 mt-1">
      {signals.map((signal) => (
        <SignalCard
          key={signal.name}
          signal={signal}
          isSelected={selectedSignals.has(signal.name)}
          isSaved={savedSignalNames.has(signal.name)}
          isExpanded={expandedSignalName === signal.name}
          onToggle={() => onToggleSignal(signal.name)}
          onSave={(e) => onSaveSignal(e, signal)}
          onExpandToggle={(e) => {
            e.stopPropagation();
            onExpandToggle(expandedSignalName === signal.name ? null : signal.name);
          }}
        />
      ))}
    </div>
  );
});

SignalList.displayName = 'SignalList';

export default SignalList;
